import { Grid as Grid$1 } from './Grid.js';
import { Column } from './Column.js';

const Grid = Object.assign(Grid$1, {
    Column,
});

export { Grid };
